<template>
    <section>
      <el-dialog
        title="添加智能体"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="addForm"
          label-width="120px"
          :rules="addFormRules"
          ref="addForm"
        >
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="智能体ID" prop="BotID">
            <el-input v-model="addForm.BotID" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="应用ID" prop="AppID">
            <el-input v-model="addForm.AppID" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="公钥" prop="PublicKey">
            <el-input v-model="addForm.PublicKey" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="私钥" prop="PrivateKey">
            <el-input v-model="addForm.PrivateKey" auto-complete="off"></el-input>
          </el-form-item>
        
          <el-form-item label="开场问候语" prop="Greet">
            <el-input v-model="addForm.Greet" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="英语开场问候语" prop="Greet">
            <el-input v-model="addForm.Greet_en" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { addBots, BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        addFormVisible:true,
        options: [],
        addForm: {
          Id:0,
          Name: "",
          BotID:"",
          AppID:"",
          PublicKey:"",
          PrivateKey:"",
          Greet:"您好，请问有什么可以帮助您。",
          Greet_en: "Hello, how can I help you?",
        },
        addLoading: false,
        clinicLoading:false,
        addFormRules: {
         
        },
      };
    },
    methods: {
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              addBots(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
     
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
     

    },
  };
  </script> 